import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import SVG from 'components/SVG';

import { selectSportHistoryLocale } from 'features/sportHistory/redux/selectors';
import arrowDownSVG from 'features/sportHistory/img/arrow-down.svg';

import StakeItem from '../StakeItem';
import './BetItem.scss';

const b = block('bet-item');

const BetItem = ({ item }) => {
  const locale = useSelector(selectSportHistoryLocale);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={b()}>
      <div className={b('main', { status: item.status })}>
        <div className={b('item')}>
          <div className={b('label')}>{locale.event}</div>
          <div className={b('value')}>{item.eventName}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.eventType.title}</div>
          <div className={b('value')}>{item.isLive ? locale.eventType.live : locale.eventType.offline}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.region}</div>
          <div className={b('value')}>{item.countryName}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.tournament}</div>
          <div className={b('value')}>{item.tournamentName}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.sport}</div>
          <div className={b('value')}>{item.sportName}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.outcome}</div>
          <div className={b('value')}>{item.outcome}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.coef}</div>
          <div className={b('value')}>{item.coef}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.score}</div>
          <div className={b('value')}>{item.score}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.status.title}</div>
          <div
            className={b('value', {
              status: item.status,
            })}>
            {locale.status?.[item.status] ?? item.status}
          </div>
        </div>

        <div />

        {item.isBetBuilder && (
          <SVG
            containerClassName={b('arrow', { isOpen })}
            svgProps={{ svg: arrowDownSVG }}
            onClick={() => setIsOpen(!isOpen)}
          />
        )}
      </div>
      {item.isBetBuilder && isOpen && item.betBuilderStakes?.map(v => <StakeItem key={item.outcome} item={v} />)}
    </div>
  );
};

export default BetItem;
